import { render, staticRenderFns } from "./CustomPaymentIBD.vue?vue&type=template&id=58a3ba12&scoped=true&"
import script from "./CustomPaymentIBD.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentIBD.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentIBD.vue?vue&type=style&index=0&id=58a3ba12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a3ba12",
  null
  
)

export default component.exports